import React from 'react'
import TextField from '@material-ui/core/TextField'
import Autocomplete, { createFilterOptions } from '@material-ui/lab/Autocomplete'
import {useTags, useProcesses, setPlan} from '../redux/plan'
const filter = createFilterOptions()

export default function Auto(props) {
  const tags = useTags()
  const proc = useProcesses()
  const data = props.type === 'Process' ? proc : tags[props.tag]

  return (
    <Autocomplete
    multiple
      onChange={(event, newValue) => {
          props.updateProcess(props.tag, newValue)
      }}
      defaultValue={props.value}
      selectOnFocus
      clearOnBlur
      handleHomeEndKeys
      id={props.id}
      options={data}
      getOptionLabel={(option) => {
        return option
      }}
      renderOption={(option) => option}
      renderInput={(params) => (
        <TextField {...params} label={props.title} 
         />
        )}
      
    />
  )
}
